<section id="opzeggen-section">
    <h1>Opzeggen verzekering</h1>

    <ng-container *ngIf="purchasedProducts">
        <p>Kies hieronder welke verzekering u wilt opzeggen.</p>
        <ng-container *ngFor="let purchasedProduct of purchasedProducts">
            <ins-cancel-insurance-list [purchasedProduct]="purchasedProduct"></ins-cancel-insurance-list>
        </ng-container>
    </ng-container>
</section>
